export default "__VITE_ASSET__CbsuDM3H__"